import { Route } from "react-router-dom";
import AuthLayout from "../containers/AuthLayout";

const AuthRoute = ({ component: Component, ...rest }: any) => (
    <Route
      {...rest}
      render={(props) => (
        <AuthLayout>
          <Component {...props} />
        </AuthLayout>
      )}
    />
  );
  export default AuthRoute;